import React from "react"

// type designation =
//   | "Science & Technology"
//   | "The Swimming Pool"
//   | "Bursaries (relief of fees)"
//   | "Where most needed"

type designation =
  | "Where Most Needed"
  | "Bursary Programme"
  | "Capital Projects"

const designations: designation[] = [
  "Where Most Needed",
  "Bursary Programme",
  "Capital Projects",
]

export interface BrickRow {
  type: string | null
  designation: designation
  line_1: string
  line_2: string
  line_3: string
  line_4: string
}

type Props = {
  index: number
  value: BrickRow
  onChange(value: BrickRow): void
  showTerms(): void
}

const BrickForm: React.FC<Props> = ({ index, value, onChange, showTerms }) => {
  const rowNumber = index + 1

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 lg:gap-16 bg-[#f2f1f0] py-3 px-4 lg:px-6 mt-6">
      <div className="col-span-1 md:col-span-1">
        <div className="flex gap-2 items-center text-2xl font-gilroy font-bold">
          PAVIOUR{" "}
          <span className="w-8 aspect-square rounded-full flex items-center justify-center bg-[#f3b247]">
            {rowNumber}
          </span>
        </div>
        <div className="pt-4">
          <div className="font-gilroy-light">
            Type of paviour <span>*</span>
          </div>
          <select
            className="input w-full"
            value={value.type}
            onChange={(e) => onChange({ ...value, type: e.target.value })}
          >
            <option value={null}> - Select - </option>
            <option value="800">
              Single paviour with two lines of text - £800
            </option>
            <option value="1600">
              Double paviour with four lines of text - £1600
            </option>
          </select>
        </div>
        <div className="pt-4 pb-2 font-gilroy-light">
          I would like my gift to be designated for
        </div>
        <div className="flex flex-col gap-1">
          {designations.map((designation) => (
            <div key={designation}>
              <label
                htmlFor={`${designation.replace(" ", "_")}-${rowNumber}`}
                className="flex gap-4 items-center font-gilroy-light"
              >
                <input
                  type="radio"
                  value={designation}
                  name={`brick_place-${rowNumber}`}
                  id={`${designation.replace(" ", "_")}-${rowNumber}`}
                  checked={value.designation === designation}
                  onChange={() =>
                    onChange({ ...value, designation: designation })
                  }
                />
                {designation}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div className="col-span-1 md:col-span-2">
        <div className="font-gilroy font-bold pb-4">PAVIOUR INSCRIPTION</div>
        <div className="flex flex-col gap-2">
          {[...Array(value.type === "1600" ? 4 : 2)].map((_, index) => (
            <input
              key={index}
              className="input w-full"
              type="text"
              maxLength={16}
              placeholder={`Line ${index + 1}...`}
              value={value[`line_${index + 1}`]}
              onChange={(e) =>
                onChange({ ...value, [`line_${index + 1}`]: e.target.value })
              }
            />
          ))}
        </div>
        <div className="flex flex-col items-start sm:justify-between sm:items-center sm:flex-row pt-4">
          <div className="text-[#8f969c] font-gilroy-light">
            Max 16 characters per line, please use upper and lower case
          </div>
          <div>
            <a
              className="link font-gilroy-light"
              onClick={(e) => {
                e.preventDefault()
                showTerms()
              }}
            >
              Terms and Conditions
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BrickForm
